import { render, staticRenderFns } from "./DepartmentItem.vue?vue&type=template&id=c85d7e3a&"
import script from "./DepartmentItem.vue?vue&type=script&lang=js&"
export * from "./DepartmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports